<ng-container *ngIf="trimmedName">
    <span *ngIf="rendersUppSvg" class="upp-icon__canvas" [innerHTML]="svgHtml"></span>
    <i *ngIf="!rendersUppSvg && rendersFaIcon" class="upp-icon__fa" [class]="fontAwesomeClassName"></i>
    <ion-icon *ngIf="!rendersUppSvg && !rendersFaIcon" [name]="trimmedName" [color]="colorForIon"></ion-icon>
</ng-container>
